


















import { Component, Prop, Vue } from "vue-property-decorator";
import Select from "@/components/common/widget/Select.vue";
import { Question } from "@/store/modules/lib";
@Component({
  name: "LfsSelectBox",
  components: { Select },
})
export default class LfsSelectBox extends Vue {
  @Prop({
    type: Object,
  })
  value!: Question;

  @Prop({
    type: String,
  })
  header!: string;

  @Prop({
    type: Array,
  })
  items!: Array<any>;

  @Prop({
    type: String,
  })
  placeholder!: string;
  get item() {
    return this.value;
  }
  // computed
  // get item() {
  //   const text = this.items.filter((item) => item.id == this.value.type)[0];
  //   const id = this.value.type == "catalog" ? "select" : this.value.type;
  //
  //   return { id, text } as any;
  // }
  // set item(newValue: string) {
  //   this.value.type = newValue;
  //   if (newValue != "select") return;
  //   this.value.type = this.value.answers.length > 5 ? "catalog" : "select";
  // }
  // methods
  handleChange() {
    // this.$emit("input", this.value);
    this.$emit("changedQuestion");
  }
}
